import React, { type FC } from "react";
import { useInboundDocument } from "src/components/Contexts/InboundDocumentContext";
import getLineItemMismatchDataTableDefinition from "src/components/Pages/DocumentInbound/Tabs/Validations/ValidationsModals/Mismatch/LineItem/line-item-mismatch-data-table-definition";
import convertToLineItemMismatchTableFields from "src/components/Pages/DocumentInbound/Tabs/Validations/ValidationsModals/Mismatch/LineItem/line-item-mismatch-table-fields-extractor";
import MismatchTable from "src/components/Pages/DocumentInbound/Tabs/Validations/ValidationsModals/Mismatch/MismatchTable";
import { orderMismatchTableByRuleSeverityAndAscendingItems } from "src/components/Pages/DocumentInbound/Tabs/Validations/ValidationsModals/Mismatch/mismatch-table-fields-extractor";
import type { ValidationModalRenderComponentProps } from "src/components/Pages/DocumentInbound/Tabs/Validations/ValidationsModals/ValidationModalRenderComponent";

const LineItemMismatchTableRenderComponent: FC<
  ValidationModalRenderComponentProps & { enableEditPurchaseOrder?: boolean }
> = ({ enableEditPurchaseOrder = false, validationGroupId }) => {
  const inboundDocument = useInboundDocument();
  const lineItemMismatchDataTableDefinition =
    getLineItemMismatchDataTableDefinition(enableEditPurchaseOrder);

  return (
    <>
      <MismatchTable
        validationGroupId={validationGroupId}
        dataTableDefinition={lineItemMismatchDataTableDefinition}
        dataTransformer={convertToLineItemMismatchTableFields(inboundDocument)}
        rowSorter={orderMismatchTableByRuleSeverityAndAscendingItems}
      />
    </>
  );
};

export default LineItemMismatchTableRenderComponent;
